import React from "react";

import DotsIcon from "@uui/DotsVertical";

import type { MenuProps } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Button from "@rui/Button";
import IconButton, { IconButtonProps } from "@rui/IconButton";
import Menu from "@rui/Menu";
import { Row } from "@rui/Stack";
import RuiTextField from "@rui/TextField";

export const POPOVER_SLOT_PROPS = {
  paper: {
    sx: { border: "1px solid", borderColor: "shades.neutral.100" },
  },
};

export const SuggestedSpeakerRow = styled(Row)(({ theme }) => ({
  alignItems: "center",
  borderRadius: "8px",
  padding: "2px",
  "& .suggested-speaker-chevron": {
    opacity: 0,
  },
  "&:hover": {
    backgroundColor: theme.palette.shades.ghost[500],
    cursor: "pointer",
  },
  "&:hover .suggested-speaker-chevron": {
    opacity: 1,
  },
  justifyContent: "space-between",
}));

export const PopoverTextField = styled(RuiTextField)({
  "& .MuiOutlinedInput-input": {
    height: "18px",
    padding: "8px",
  },
});

export const PopoverButton = styled(Button)(({ theme }) => ({
  height: "34px",
  padding: "8px 12px",
  minWidth: "56px",
  borderRadius: theme.corners.base,
}));

export const OptionButton = styled((props: IconButtonProps) => {
  return (
    <IconButton {...props}>
      <DotsIcon />
    </IconButton>
  );
})({ width: "32px", height: "32px", "& svg": { width: "16px" } });

export const EditSpeakerMenu = styled((props: MenuProps) => (
  <Menu
    elevation={1}
    transformOrigin={{ horizontal: "left", vertical: 10 }}
    anchorOrigin={{ horizontal: "right", vertical: "top" }}
    {...props}
  />
))({});
